import {
  ProofOfIdentityType,
  ResearchCategory,
  ResearchSheetType,
  Sex,
} from 'enums';

export const sexOptions = [
  {
    id: Sex.MALE,
    label: 'Male',
  },
  {
    id: Sex.FEMALE,
    label: 'Female',
  },
];

export const proofOfIdentityTypeOptions = [
  {
    id: ProofOfIdentityType.CAS,
    label: 'Document UK',
  },
  {
    id: ProofOfIdentityType.ID_CARD,
    label: 'ID card',
  },
  {
    id: ProofOfIdentityType.PASSPORT,
    label: 'Passport',
  },
  {
    id: ProofOfIdentityType.OTHER,
    label: 'Other',
  },
];

export const researchCategoryOptions = [
  {
    id: ResearchCategory.SCIENTIFIC_PUBLICATIONS,
    label: 'Scientific (study, monograph, student)',
  },
  {
    id: ResearchCategory.SCIENTIFIC_EDITIONS,
    label: 'Scientific editions of documents',
  },
  {
    id: ResearchCategory.GENEALOGY,
    label: 'Genealogical purposes',
  },
  {
    id: ResearchCategory.PERSONAL,
    label: 'Private hobby education',
  },
  {
    id: ResearchCategory.JOURNALISTIC,
    label: 'Publicist purposes',
  },
  {
    id: ResearchCategory.EXPOSITION,
    label: 'Exhibition purposes',
  },
  {
    id: ResearchCategory.OFFICE,
    label: 'For the needs of the authorities',
  },
  {
    id: ResearchCategory.CHRONICLE,
    label: 'Chronicler',
  },
];

export const researchSheetTypeOptions = [
  {
    id: ResearchSheetType.PERSONAL,
    label: 'Personal',
  },
  {
    id: ResearchSheetType.CREDENTIAL,
    label: 'Credential',
  },
];
